import React from "react";

const HealthReport = () => {
  return <div>HealthReport</div>;
};

export default HealthReport;
